$('.features__items').slick({
    infinite: true,
    slidesToShow: 3,
    arrows: false,
    dots: false,
    autoplay: true,
    draggable: false,
    autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 991,
            draggable: true,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});


$('#offers__slider--universal').slick({
    infinite: false,
    slidesToShow: 5,
    arrows: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    draggable: false,
    
    prevArrow: $('#arrow-left--universal'),
    nextArrow: $('#arrow-right--universal'),
    responsive:[
        {
            breakpoint: 1500,
            settings:{
                slidesToShow: 4
            }
        },
        {
            breakpoint: 1200,
            settings:{
                slidesToShow: 3
            }
        },
        {
            breakpoint: 991,
            arrows: false,
            draggable: true,
            settings:{
                slidesToShow: 2
            }
        },
        {
            breakpoint: 576,
            settings:{
                slidesToShow: 1
            }
        }
    ]
});

$('#offers__slider--promo').slick({
    infinite: false,
    slidesToShow: 5,
    arrows: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    draggable: false,
    
    prevArrow: $('#arrow-left--promo'),
    nextArrow: $('#arrow-right--promo'),
    responsive:[
        {
            breakpoint: 1500,
            settings:{
                slidesToShow: 4
            }
        },
        {
            breakpoint: 1200,
            settings:{
                slidesToShow: 3
            }
        },
        {
            breakpoint: 991,
            arrows: false,
            draggable: true,
            settings:{
                slidesToShow: 2
            }
        },
        {
            breakpoint: 576,
            settings:{
                slidesToShow: 1
            }
        }
    ]
});